import {useTranslation} from "react-i18next";
import {useState} from "react";
import {json} from "react-router-dom";
import {generateCampaignLearningLinks} from "../api/sendTestmailClient";
import LearningLinksDialog from "../components/Template/TemplateTableDialog/LearningLinksDialog";
import {useTestmailDialog} from "./useTestmailDialog";
import {Language} from "../model/Language";

export function useCampaignLearningLinkDialog(): [JSX.Element, JSX.Element, (campaignId: string) => void, boolean] {
    const {t} = useTranslation();
    const [languageDialog, openLanguageDialog] = useTestmailDialog();

    const [learningLinks, setLearningLinks] = useState<string[]>([]);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);

    const generateLinks = (campaignId: string, language: Language) => {
        setLoading(true);
        generateCampaignLearningLinks(campaignId, language)
            .then((res) => {
                if (!res.ok) {
                    throw json({message: `${t('campaignTable.generateLinksError')}`}, {status: 500});
                }
                setLoading(false);
                return res.json()
            })
            .then((data) => {
                setLearningLinks(data);
                setLoading(false);
                setOpen(true);
            })
            .catch((exception) => {
                setLoading(false)
                console.log(exception.message);
            });
    }

    const openDialog = (campaignId: string) => {
        openLanguageDialog(
            t('templateTable.selectLanguage'),
            "",
            (language: Language) => generateLinks(campaignId, language)
        );
    }

    const handleClose = () => {
        setOpen(false)
    }

    const dialog = <LearningLinksDialog
        open={open}
        onClose={handleClose}
        learningLinks={learningLinks}
        loading={loading}
    />

    return [dialog, languageDialog, openDialog, loading]
}

